// import { createAsyncThunk } from '@reduxjs/toolkit';
// import { fetchUserFromAPI } from './userAPI'; // Example API call
// import Cookies from "js-cookie";
// import axios from 'axios';
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export const fetchIgConversations = createAsyncThunk(
//   'instagram/fetchIgConversations',
//   async (_, { rejectWithValue }) => {
//     try {
//         const response = await axios.get(`${BASE_URL}/ig/Conversation`,{
//             headers:{
//               "Authorization":`Bearer ${ Cookies.get('token')}`
//             }
//           });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue( error?.message|| 'Error fetching Facebook conversations');
//     }
//   }
// );

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import swal from "sweetalert";

const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API base URL

// Thunks for API calls

export const fetchFBConversations = createAsyncThunk(
  "facebook/fetchFbConversations",
  async (_, { rejectWithValue }) => {
    try {
      // const response = await axios.get(`${BASE_URL}/FB/Conversation`, {
      const response = await axios.get(`${BASE_URL}/facebook/all`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
// export const getConversationByUser = createAsyncThunk(
//   "chat/getConversationByUser",
//   async ({ currentChatId, page, limit, platform }, { rejectWithValue }) => {
//     try {
//       console.log(currentChatId, "-----------Conversation ID-----------");

//       let response;

//       const headers = {
//         Authorization: `Bearer ${Cookies.get("token")}`,
//       };

//       if (platform === "facebook") {
//         response = await axios.get(`${BASE_URL}/FB/message/${currentChatId}`, {
//           headers,
//           params: { page, limit },
//         });
//       } else if (platform === "instagram") {
//         response = await axios.get(`${BASE_URL}/ig/message/${currentChatId}`, {
//           headers,
//           params: { page, limit },
//         });
//       } else if (platform === "whatsapp") {
//         response = await axios.get(
//           `${BASE_URL}/whatsapp/get-conversation/${currentChatId}`,
//           { headers }
//         );
//       }

//       return response?.data?.response;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: "Unknown error" });
//     }
//   }

export const getFBConversationByUser = createAsyncThunk(
  "facebook/getConversationByUser",
  async ({ currentChatId, page, limit, platform }, { rejectWithValue }) => {
    try {
      console.log(currentChatId, "-----------Conversation ID-----------");
      let response;

      const headers = {
        Authorization: `Bearer ${Cookies.get("token")}`,
      };

      if (platform === "facebook") {
        response = await axios.get(`${BASE_URL}/FB/message/${currentChatId}`, {
          headers,
          params: { page, limit },
        });
      } else if (platform === "instagram") {
        response = await axios.get(`${BASE_URL}/ig/message/${currentChatId}`, {
          headers,
          params: { page, limit },
        });
      } else if (platform === "whatsapp") {
        response = await axios.get(
          `${BASE_URL}/whatsapp/message/${currentChatId}`,
          { headers }
        );
      }

      console.log(response, "responseresponseresponse")
      return response?.data?.response;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Unknown error" });
    }
  }
);

export const resetUnreadCount = createAsyncThunk(
  'chat/resetUnreadCount',
  async ({ senderId, platform }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/facebook/reset-unread`, {
        receiverId: senderId,
        platform,
      }, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      }
      );
      return { senderId, platform };
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Server error');
    }
  }
);

export const facebooksendmessage = createAsyncThunk(
  "facebook/sendMessage",
  async (data, { rejectWithValue }) => {
    try {
      console.log(JSON.stringify(data), "asdasdakjsdhkajsdhkajshdkasjhik")
      const response = await axios.post(
        `${BASE_URL}/fb/message`,
        { data },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response?.data?.status === 404) {
        swal({
          title: "Error!",
          text: response?.data?.error,
          type: "error",
          confirmButtonText: "Cool"
        });
      }
      return response.data;
    } catch (error) {
      swal({
        title: "Error!",
        text: error.message,
        type: "error",
        confirmButtonText: "Cool"
      });
      return rejectWithValue(error.message);
    }
  }
);

export const addMediaToFacebook = createAsyncThunk(
  "facebook/addMedia",
  async (data, { rejectWithValue }) => {
    try {
      console.log(data, "imageUrlimageUrl");
      const response = await axios.post(`${BASE_URL}/facebook/addpost`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addMediaToStories = createAsyncThunk(
  "facebook/addStories",
  async (data, { rejectWithValue }) => {
    try {
      console.log(data, "imageUrlimageUrl");
      const response = await axios.post(
        `${BASE_URL}/facebook/addstories`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response.data, "------------response.data-----------");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const publishMediaOnInstagram = createAsyncThunk(
  "instagram/publishMedia",
  async ({ creationId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/instagram/media_publish`,
        {
          creation_id: creationId.id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const insertPostComment = createAsyncThunk(
  "facebook/insertPostComment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/facebook/addcomment`,
        {
          postid: data?.postId,
          message: data?.message,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// In src/store/facebook/facebookThunk.js
export const deletePostComment = createAsyncThunk(
  "facebook/deletePostComment",
  async ({ commentId }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${BASE_URL}/facebook/comment/${commentId}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return { commentId, status: response.data.status };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete comment");
    }
  }
);

export const getPostComments = createAsyncThunk(
  "facebook/getPostComments",
  async (postId, { rejectWithValue }) => {
    console.log(postId, "-----------------postId----------------");
    try {
      const response = await axios.get(`${BASE_URL}/facebook/post/${postId}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(
        response.data.data,
        "-----------------commentpostId----------------"
      );
      return { postId: postId, comments: response.data.data };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const FBDisconnect = createAsyncThunk(
  "facebook/disconnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/user/FB/disconnect`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const FBProfile = createAsyncThunk(
  "facebook/getProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/facebook/fbProfile`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(
        response.data,
        "----------------igprofile---------------------------"
      );
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const FBautochat = createAsyncThunk(
  "facebook/FBautochat",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/fb/autochat/${data?.currentChatId}`,
        {
          autochat: data?.autochat,
          platform: data?.platform
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(
        response,
        "response.data.responseresponse.data.responseresponse.data.responseresponse.data.responseresponse.data.response"
      );
      // const { data, recipient, senderId } = response.data.response;
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const FbhandleLogoutAndReLogin = createAsyncThunk(
  "facebook/FbhandleLogoutAndReLogin",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/user/facebook/logout/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(
        response
        // "----------------igprofile---------------------------"
      );
      return response; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getFbstories = createAsyncThunk(
  "facebook/getFbstories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/facebook/fbstories`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(response, "getFbstoriesgetFbstories")
      console.log(
        response.data.data.data,
        "----------------getFbstories---------------------------"
      );

      return response.data.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
